import Vue from 'vue'
import axios from 'axios'
import store from '../../store'

const state = {
  shipmentsAccess: false,
  companyName: null,
  companyId: null,
  parkingModuleAccess: localStorage.getItem('provider-parking-module')
    ? JSON.parse(localStorage.getItem('provider-parking-module'))
    : null,
};

const getters = {
  getShipmentsAccess: state => state.shipmentsAccess,
  getProviderCompanyName: state => state.companyName,
  getProviderCompanyId: state => state.companyId,
  getProviderParkingModule: state => state.parkingModuleAccess,
  providerHasParkingModule: state => {
    if (!state.parkingModuleAccess || !Array.isArray(state.parkingModuleAccess.host_companies)) {
      return false;
    }
    return state.parkingModuleAccess.host_companies.some(host => host && host.enable_parking === true);
  },
  getProviderParkingHostCompanies: state => {
    if (!state.parkingModuleAccess || !Array.isArray(state.parkingModuleAccess.host_companies)) {
      return [];
    }
    return state.parkingModuleAccess.host_companies.filter(host => host && host.enable_parking === true);
  },
};

const actions = {
  FETCH_SHIPMENTS_ACCESS: ({ commit }) => {
    return new Promise((resolve, reject) => {
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/my-shipments-access/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
      };

      axios(config)
        .then(resp => {
          commit('SET_SHIPMENTS_ACCESS', resp.data);
          resolve(resp.data);
        })
        .catch(err => {
          commit('SET_SHIPMENTS_ACCESS', null);
          reject(err);
        });
    });
  },
  FETCH_PROVIDER_PARKING_MODULE: ({ commit }) => {
    return new Promise((resolve, reject) => {
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/provider/parking-module/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
      };

      axios(config)
        .then(resp => {
          commit('SET_PROVIDER_PARKING_MODULE', resp.data);
          resolve(resp.data);
        })
        .catch(err => {
          commit('SET_PROVIDER_PARKING_MODULE', null);
          reject(err);
        });
    });
  },
};

const mutations = {
  SET_SHIPMENTS_ACCESS: (state, payload) => {
    if (payload) {
      state.shipmentsAccess = payload.enable_shipments_access || false;
      state.companyName = payload.company_name || null;
      state.companyId = payload.company_id || null;
    } else {
      state.shipmentsAccess = false;
      state.companyName = null;
      state.companyId = null;
    }
  },
  SET_PROVIDER_PARKING_MODULE: (state, payload) => {
    state.parkingModuleAccess = payload;
    if (payload) {
      localStorage.setItem('provider-parking-module', JSON.stringify(payload));
    } else {
      localStorage.removeItem('provider-parking-module');
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
}
